import React from 'react'

import { TableCell as MuiTableCell } from '@mui/material'
import classNames from 'classnames'
import get from 'lodash/get'

import type { ColumnConfig } from './types'

type TableCellProps = {
  cell: ColumnConfig
  data: Record<string, any>
  index?: number
}

const TableCell = ({ cell, data }: TableCellProps) => {
  const classes = classNames('table__cell', {
    'table__cell--no-break': !!cell.noBreak,
  })

  const value = cell.render ? cell.render(data) : get(data, cell.field ?? '')

  return (
    <MuiTableCell
      align={cell.align || 'left'}
      className={classes}
      component="td"
      // An action cell shields its whole width, so missing the control does not trigger the row link.
      onClick={cell.noRowClick ? (event: React.MouseEvent) => event.stopPropagation() : undefined}
      style={cell.style}
      title={typeof value === 'string' ? value : undefined}>
      {value}
    </MuiTableCell>
  )
}

export default TableCell
